import React from "react";
import "./Placement_Support.css";
import Explore_Btn from "../../common/explore-btn/Explore_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper/modules";

const Placement_Support = () => {
  const navigate = useNavigate();
  const program_list = useSelector((state) => state?.common?.all_program_list);

  const programData = [
    {
      id: 1,
      title: "Executive Profile Engineering",
      image: "/assets/images/home/Placement_Support/img-1.png",
      points: [
        "ATS-Optimized Resume crafted to clear automated screening systems",
        "Executive-Level Resume Positioning aligned with enterprise roles",
        "Strategic LinkedIn Optimization for recruiter visibility",
        "Profile Structuring across top hiring platforms"
      ],
    },
    {
      id: 2,
      title: "Strategic Referral Network Access",
      image: "/assets/images/home/Placement_Support/img-2.png",
      points: [
        "Access to our Alumni & Industry Mentor Network",
        "Guided Referral Strategy for Target Companies",
        "Personalized Referral Support from Senior Instructors",
        "Direct insights into company-specific openings"
      ],
    },
    {
      id: 3,
      title: "Corporate Hiring Partnerships",
      image: "/assets/images/home/Placement_Support/img-3.png",
      points: [
        "500+ Hiring Network Touchpoints & Industry Connects",
        "Curated Job Opportunities Shared with Eligible Learners",
        "Interview Connects with Growing Tech & Enterprise Firms",
        "Structured Follow-Up & Interview Feedback Support"
      ],
    },
  ];

  return (
    <section className="Placement_Support">
      <div className="container">
        <div className="Placement_Support_header">
          <h5 className="title">
            Placement <span>Support</span>
          </h5>
          <p className="subtitle">
            Our 3-Step Approach To Get You Interview-Ready And Placed
          </p>

          <p className="subtitle">
            At <strong>PST IT Solutions</strong>, placement support is not an add-on service.
            It is a carefully engineered career acceleration framework designed to position you for high-value roles in Data Engineering and Analytics.
          </p>
        </div>

        <div className="program_section">
          {programData.length > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              // navigation
              autoplay={{
                delay: 4500,
                disableOnInteraction: false,
              }}
              loop={programData.length > 3}
              breakpoints={{
                320: { slidesPerView: 1 },
                576: { slidesPerView: 1.2 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {programData.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="program_box">
                    <div className="program_image">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="card_img"
                      />
                    </div>

                    <div className="program_content">
                      <h5 className="program_title">{item.title}</h5>

                      {item.points.map((point, index) => (
                        <div key={index} className="program_point">
                          <span className="check-icon">
                            <FontAwesomeIcon
                              icon={faSquareCheck}
                              style={{
                                color: "#13ADF4",
                                fontSize: "15px",
                              }}
                            />
                          </span>
                          <span>{point}</span>
                        </div>
                      ))}
                    </div>

                    <div className="explore_btn">
                      {/* <Explore_Btn
                        onClick={() => navigate("/explore-program")}
                      /> */}
                      <Explore_Btn
                        onClick={() => {
                          if (program_list?.length > 0) {
                            navigate(`/explore-program/${program_list[0].id}`);
                          }
                        }}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default Placement_Support;
